(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mise", [], factory);
	else if(typeof exports === 'object')
		exports["mise"] = factory();
	else
		root["mise"] = factory();
})(window, function() {
return 